// extracted by mini-css-extract-plugin
export default {"notice":"BiScVp9o_KO9ZlMmG08S","pending":"qLP5HTZ2lR8n4WWFB3ak","error":"o7nFaWCJzToozHU_fCNc"};